export default "__VITE_ASSET__CbdfXBgU__"